/**
 * 检测模块
 */
import _ from 'lodash'
import checkApi from '../../api/check.api'
import http from "../../api/http";

const state = {
    token: '',
    //是否检测完成
    isFinish: false,
    //是否需要排队
    isQueue: false,
    //进度数据
    progressData: {
        title: '正在进行诊断...',
        subTitle: '',
        progress: 0,
        score: 100,
        pageNumber: 1,
        alreadyCount: 0,
        waitingCount: 0,
        notCount: 0
    },
    // 诊断项分类列表
    classifyList: [],
    //检测列表数据
    listData: [],
    //网站指数
    webIndex: 0,
    //显示报告页
    showReport: false,
    // 显示pk页
    pkVisible: false
};

const getters = {
    // 根据分数显示不同提示
    getTitle: state => score => {
        score = score || state.progressData.score;
        let hint = [
            '您的网站完全没有营销力，建议立即进行人工诊断',
            '您的网站几乎没有营销力，建议您立即重新建站',
            '您的网站几乎没有营销力，建议您立即重新建站',
            '您的网站几乎没有营销力，建议您立即重新建站',
            '您的网站几乎没有营销力，建议您立即重新建站',
            '您的网站营销力和优化极弱，建议立即优化',
            '您的网站营销力和优化极弱，建议立即优化',
            '您的网站营销力和优化偏弱，建议您进行优化',
            '您的网站营销力和优化稍弱，建议您进行优化',
            '您的网站营销力和优化良好，调整下会更好',
            '您的网站营销力和优化非常好，注意调整下就可以了',
            '你的网站营销力，火力十足，堪称完美!'
        ];
        return score === 0 ? hint[0] : hint[Math.floor(score/10+1)];
    },
    getListData: (state, getters) => {
        return _.flatMap(_.cloneDeep(state.classifyList), classify => {
            classify.children = _.filter(state.isFinish ? getters.successList : state.listData, {classify: classify.key});
            return classify.children.length ? classify : [];
        })
    },
    failList: state => {
        return _.filter(state.listData, {result: false});
    },
    successList: state => {
        return _.filter(state.listData, {result: true});
    },
    getReportPDFUrl: (state, getters, rootState) => {
        return checkApi.getReportPDF(rootState.user._id, state.token);
    },
    downloadPDFUrl: (state, getters, rootState) => {
        return checkApi.getReportPDF(rootState.user._id, state.token, true);
    }

};

const mutations = {
    //设置token
    setToken (state, token) {
        state.token = token;
    },
    //设置排队状态
    setQueue (state, isQueue) {
        state.isQueue = isQueue;
    },
    // 设置诊断项分类列表数据
    setClassify (state, data) {
        state.classifyList = data;
    },
    //重置进度数据
    resetProgressData (state) {
        state.progressData.pageNumber = 1;
        state.progressData.alreadyCount = state.progressData.waitingCount = state.progressData.notCount = 0;
    },
    //设置进度数据
    setProgressData (state, data) {
        Object.assign(state.progressData, data);
    },
    //转换进度数据
    convertProgress (state, data) {
        let filter = state.isFinish ? ['data'] : ['data', 'score'];
        Object.assign(state.progressData, _.omit(data, filter));
        let errorLength = _.sumBy(state.listData, item => item.result ? 0 : 1);
        if (!state.isFinish) {
            state.progressData.subTitle = errorLength ? `发现<span class="error">${errorLength}</span>个问题，请检测完成后点击图标了解详情`
                : '尚未发现问题，请耐心等待检测完成';
        } else {
            state.progressData.subTitle = !errorLength ? `检测完毕，没有发现任何问题`
                : `发现<span class="error">${errorLength}</span>个问题，请点击下方橙色图标了解问题详情`;
            if (state.progressData.score === 0) {
                state.progressData.subTitle = '';
            }
        }
    },
    //根据进度设置对应数量的检测结果
    setProgressList (state, data) {
        let score = 100;
        data.data = _.isArray(data.data) ? data.data : [];
        // 计算分类总分数
        _.forEach(state.classifyList, classify => {
            let currentScore = _.sumBy(_.filter(data.data, {classify: classify.key, result: false}), 'score');
            score -= currentScore > classify.score ? classify.score : currentScore;
        });
        state.progressData.title = '正在进行诊断：' + (_.last(data.data) || {}).title;
        state.progressData.score = score > state.progressData.score ? state.progressData.score : score;
        state.listData = data.data.reverse();
    },
    //设置检测列表数据
    setListData: (state, list) => {
        state.listData = (list[0] || {}).children ? _.flatMap(list, 'children') : list;
    },
    //设置是否检测完成
    setFinish (state, value) {
        state.isFinish = value;
    },
    reset (state) {
        state.token = '';
        state.isFinish = false;
        state.progressData.progress = 0;
        state.progressData.score = 100;
        state.listData = [];
    },
    //设置网站指数
    setWebIndex (state, data) {
        state.webIndex = data;
    },
    //是否显示报告页
    setReportVisible(state, isShow) {
        state.showReport = isShow;
    },
    // 设置PK页
    setPKVisible(state, val) {
        state.pkVisible = val;
    }
};

const actions = {
    // 获取诊断项分类
    getClassify ({state, commit}) {
        return state.classifyList.length ? state.classifyList : checkApi.getClassify().then(res => {
            commit('setClassify', res);
            return res;
        })
    },
    // 启动
    start ({commit}, params) {
        return checkApi.startRC(params).then(data => {
            commit('setUserInfo', _.pick(data, ['freeCheckCount', 'extraCheckCount']), {root: true});
            commit('setToken', data.token);
            commit('setFinish', !!data.isFinish);
            commit('resetProgressData');
            return data;
        })
    },
    startOther  ({}, params) {
    return checkApi.startOther(params)
},
    // 获取进度数据
    async getProgress ({state, commit}) {
        return checkApi.getProgress(state.token).then(data => {
            data.progress=data.progress+14;
            if(data.progress<114&&data.progress>=100){
                data.progress=95;
            }if(data.progress===114){
                data.progress=100;
            }
            commit('setProgressList', data);
            commit('convertProgress', data);
            return data;
        })
    },
    // 获取列表数据
    getList ({state, commit}) {
        return checkApi.getListData(state.token).then(data => {
            commit('setFinish', true);
            commit('setListData', data.data);
            commit('convertProgress', data);
            return data;
        });
    },
    // 取消检测
    cancel ({state, commit}) {
        return checkApi.cancel(state.token).then(message => {
            commit('setFinish', true);
            commit('setProgressData', {
                title: message,
                subTitle: '',
                progress: 100
            });
            commit('setListData', []);
            return message;
        });
    },
    // pk: 启动
    startPK ({state}, params) {
        params.fromToken = state.token;
        return checkApi.startPK(params);
    },
    // pk: 获取进度数据
    getProgressPK ({}, token) {
        return checkApi.getProgress(token);
    },
    // pk: 获取列表数据
    getListPK ({}, token) {
        return checkApi.getListData(token).then(res => {
            res.data = _.flatMap(res.data, 'children');
            return res;
        })
    },
    // pk: 取消诊断
    cancelPK ({}, token) {
        return checkApi.cancel(token);
    },
    // 获取单个检查项数据
    getItemData ({}, id) {
        return checkApi.getItemData(state.token, id);
    },
    //追回分数
    recoverScore ({state, commit}, item) {
        return checkApi.recoverScore(state.token, item).then(data => {
            commit('setListData', data.data);
            commit('convertProgress', data);
            return '成功追回分数';
        }, () => {
            return '追回分数失败';
        });
    },
    //验证是否在检测黑名单中
    hascheckblack ({}, url) {
        return checkApi.hascheckblack(url);
    },
    //获取排队情况
    getQueueUp () {
        return checkApi.getQueueUp();
    },
    //获取网站指数
    getWebIndex ({state, commit}) {
        return checkApi.getWebIndex(state.token, state.progressData.score).then(res => {
            commit('setWebIndex', res.index);
            return res;
        });
    },
    //获取所有页面数
    getPageNumber() {
        return checkApi.getPageNumber();
    },
    //生成报告
    hasCreateReport() {
        return checkApi.hasCreateReport();
    },
    // 获取所属企业诊断最多的网站
    getMostCheckResult() {
        return checkApi.getMostCheckResult();
    },
    // 获取所属企业组历史诊断过的网站
    getWebSiteNum() {
        return checkApi.getWebSiteNum();
    },
    // 获取所属企业组历史诊断网站详情数据
    getResultByUrlInGroup({}, token) {
        return checkApi.getResultByUrlInGroup(token);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./app/store/modules/check.js